// ── Cart Drawer ───────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const drawer   = document.getElementById('cart-drawer');
  const overlay  = document.getElementById('cart-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const bodyEl   = document.getElementById('cart-drawer-body');
  const footerEl = document.getElementById('cart-drawer-footer');
  const countEl  = document.getElementById('cart-count');
  const subtotalDrawerEl = document.getElementById('cart-drawer-subtotal');

  if (!drawer) return;

  let currentItems = [];

  function fmt(cents, currency) {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
  }

  function esc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function updateCount(count) {
    if (!countEl) return;
    countEl.textContent = count;
    count > 0 ? countEl.removeAttribute('hidden') : countEl.setAttribute('hidden', '');
  }

  function renderItems(cart) {
    currentItems = cart.items;
    updateCount(cart.item_count);
    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<p class="cart-drawer__empty">Il tuo carrello è vuoto.</p>';
      footerEl.setAttribute('hidden', '');
      return;
    }
    bodyEl.innerHTML = cart.items.map((item, i) => {
      const imgUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url.split('?')[0] + '?width=160'
        : null;
      const imgHtml = imgUrl
        ? `<img src="${imgUrl}" alt="${esc(item.title)}" class="cart-drawer__item-image" loading="lazy" width="80" height="80">`
        : `<div class="cart-drawer__item-image cart-drawer__item-image--placeholder">🛍️</div>`;
      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-drawer__item-variant muted">${esc(item.variant_title)}</p>` : '';
      return `
        <div class="cart-drawer__item" data-index="${i}">
          <a href="${esc(item.url)}" class="cart-drawer__item-image-link">${imgHtml}</a>
          <div class="cart-drawer__item-info">
            <a href="${esc(item.url)}" class="cart-drawer__item-title">${esc(item.product_title)}</a>
            ${variantHtml}
            <p class="cart-drawer__item-price">${fmt(item.final_line_price, cart.currency)}</p>
            <div class="cart-drawer__item-controls">
              <div class="cart-drawer__qty">
                <button class="qty-btn drawer-qty-btn" data-index="${i}" data-delta="-1" aria-label="Diminuisci">−</button>
                <span>${item.quantity}</span>
                <button class="qty-btn drawer-qty-btn" data-index="${i}" data-delta="1" aria-label="Aumenta">+</button>
              </div>
              <button class="cart-drawer__remove" data-line="${i + 1}" aria-label="Rimuovi">Rimuovi</button>
            </div>
          </div>
        </div>`;
    }).join('');
    subtotalDrawerEl.textContent = fmt(cart.total_price, cart.currency);
    footerEl.removeAttribute('hidden');

    bodyEl.querySelectorAll('.drawer-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = +btn.dataset.index;
        const newQty = currentItems[idx].quantity + (+btn.dataset.delta);
        changeQty(idx + 1, newQty);
      });
    });
    bodyEl.querySelectorAll('.cart-drawer__remove').forEach(btn => {
      btn.addEventListener('click', () => changeQty(+btn.dataset.line, 0));
    });
  }

  async function refresh() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      renderItems(cart);
    } catch(e) { console.error('Cart refresh error', e); }
  }

  async function changeQty(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, quantity) })
      });
      await refresh();
    } catch(e) { console.error('Cart change error', e); }
  }

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
    refresh();
    setTimeout(() => closeBtn && closeBtn.focus(), 100);
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    document.getElementById('cart-icon-btn')?.focus();
  }

  // Bind open/close
  document.getElementById('cart-icon-btn')?.addEventListener('click', e => { e.preventDefault(); open(); });
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  // Intercept add-to-cart forms
  document.querySelectorAll('form[action*="cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[name="add"]');
      const origText = btn?.textContent || '';
      if (btn) { btn.disabled = true; btn.textContent = 'Aggiunto...'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Errore'); }
        open();
      } catch(err) {
        console.error(err);
        alert(err.message || 'Impossibile aggiungere al carrello.');
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = origText; }
      }
    });
  });

  // Init count (DOMContentLoaded + bfcache restore)
  function syncCount() {
    fetch('/cart.js').then(r => r.json()).then(c => updateCount(c.item_count)).catch(() => {});
  }
  syncCount();
  window.addEventListener('pageshow', function(e) { if (e.persisted) syncCount(); });

  // Cart page: quantity buttons
  document.querySelectorAll('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = +btn.dataset.line;
      const input = document.querySelector(`.cart-qty-input[data-line="${line}"]`);
      if (!input) return;
      let qty = parseInt(input.value, 10);
      qty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      input.value = qty;
      try {
        const cart = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: qty })
        }).then(r => r.json());
        updateCount(cart.item_count);
        const st = document.getElementById('cart-subtotal');
        if (st) st.textContent = fmt(cart.total_price, cart.currency);
        if (qty === 0) document.querySelector(`.cart-item[data-line="${line}"]`)?.remove();
        if (cart.item_count === 0) window.location.reload();
      } catch(e) { console.error(e); }
    });
  });

  // Cart page: remove buttons
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = +btn.dataset.line;
      try {
        const cart = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        }).then(r => r.json());
        updateCount(cart.item_count);
        document.querySelector(`.cart-item[data-line="${line}"]`)?.remove();
        const st = document.getElementById('cart-subtotal');
        if (st) st.textContent = fmt(cart.total_price, cart.currency);
        if (cart.item_count === 0) window.location.reload();
      } catch(e) { console.error(e); }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {

  // ── Product gallery carousel ──────────────────────────────────────────
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;

    const slides = track.querySelectorAll('.gallery-slide');
    const dotsWrap = gallery.querySelector('[data-gallery-dots]');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-index]')) : [];
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    let current = 0;
    const total = slides.length;

    function goTo(index) {
      current = ((index % total) + total) % total;
      track.scrollTo({ left: current * track.offsetWidth, behavior: 'smooth' });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));
    dots.forEach(d => d.addEventListener('click', () => goTo(+d.dataset.index)));

    track.addEventListener('scroll', () => {
      const idx = Math.round(track.scrollLeft / track.offsetWidth);
      if (idx !== current) {
        current = idx;
        dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      }
    }, { passive: true });
  });

  // ── Generic photo slider ──────────────────────────────────────────────
  document.querySelectorAll('[data-slider]').forEach(slider => {
    const track = slider.querySelector('[data-slider-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.photo-slider__slide'));
    const dotsContainer = slider.querySelector('[data-slider-dots]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    let current = 0;
    const total = slides.length;

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'slider-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Foto ' + (i + 1));
      dot.addEventListener('click', () => goTo(i));
      if (dotsContainer) dotsContainer.appendChild(dot);
    });

    function getDots() {
      return dotsContainer ? Array.from(dotsContainer.querySelectorAll('.slider-dot')) : [];
    }

    function goTo(index) {
      current = ((index % total) + total) % total;
      track.scrollTo({ left: current * track.offsetWidth, behavior: 'smooth' });
      getDots().forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));

    track.addEventListener('scroll', () => {
      const idx = Math.round(track.scrollLeft / track.offsetWidth);
      if (idx !== current) {
        current = idx;
        getDots().forEach((d, i) => d.classList.toggle('is-active', i === current));
      }
    }, { passive: true });
  });

  // ── Animated FAQ accordion ────────────────────────────────────────────
  document.querySelectorAll('.faq__item').forEach(details => {
    const summary = details.querySelector('summary');
    const body = details.querySelector('.muted');
    if (!summary || !body) return;
    body.style.overflow = 'hidden';
    body.style.transition = 'max-height .3s ease, padding .3s ease';
    body.style.maxHeight = '0';
    summary.addEventListener('click', e => {
      e.preventDefault();
      if (!details.open) {
        details.open = true;
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        body.style.maxHeight = '0';
        setTimeout(() => { details.open = false; }, 310);
      }
    });
  });

  // ── Sticky ATC bar (mobile) ───────────────────────────────────────────
  const stickyAtc = document.getElementById('sticky-atc');
  const productPanel = document.getElementById('product-form');
  if (stickyAtc && productPanel) {
    const obs = new IntersectionObserver(([entry]) => {
      stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    obs.observe(productPanel);
  }

});
